/**
 * custom-nav-overflow.js  (feature: nav-restructure — CRO #1–3)
 *
 * Priority-plus ("More" overflow) navigation for the classic header. With six
 * top-level items, the desktop nav can wrap to multiple rows before the 798px
 * hamburger kicks in. This measures the nav and, when items wrap, moves the
 * trailing items into a compact "More" dropdown (and moves them back out as the
 * window widens). The three Shop mega-menu items are never moved (they carry the
 * mega menus). Below 799px it stays out of the way — the theme's hamburger menu
 * handles everything.
 *
 * Self-contained: no globals, no changes to compiled/base files. Loaded from
 * sections/header-classic.liquid.
 */
(function () {
  var nav = document.querySelector('#header .header__menu-items');
  if (!nav) return;

  var DESKTOP_MIN = 799; // matches the theme's mobile-menu breakpoint

  // Build the "More" item (styled like a nav item; hidden until needed)
  var moreItem = document.createElement('div');
  moreItem.className = 'navbar-item header__item priority-more';
  moreItem.setAttribute('data-priority-more', '');
  moreItem.style.display = 'none';
  moreItem.innerHTML =
    '<a href="#" class="navbar-link header__link priority-more__toggle" role="button" aria-haspopup="true" aria-expanded="false">' +
      'More<span class="priority-more__caret" aria-hidden="true">▾</span>' +
    '</a>' +
    '<div class="priority-more__panel"></div>';
  nav.appendChild(moreItem);

  var toggle = moreItem.querySelector('.priority-more__toggle');
  var panel = moreItem.querySelector('.priority-more__panel');

  // Direct .navbar-item children of the nav (excludes items already in the panel)
  function directItems() {
    return Array.prototype.filter.call(nav.children, function (el) {
      return el.classList && el.classList.contains('navbar-item');
    });
  }

  // Keep the first top-level item (Shop Collections) always in the bar as an
  // anchor; everything after it may overflow into "More", including the other
  // Shop mega items (their mega menu is hidden while in the panel — see CSS).
  var protectedFirst = null;
  (function () {
    var d = directItems();
    for (var i = 0; i < d.length; i++) {
      if (d[i] !== moreItem) { protectedFirst = d[i]; break; }
    }
  })();

  function isMovable(item) {
    return item !== moreItem && item !== protectedFirst;
  }

  function isWrapping() {
    var items = directItems();
    var base = null;
    for (var i = 0; i < items.length; i++) {
      if (items[i].offsetParent === null) continue; // skip hidden (e.g. More when off)
      if (base === null) { base = items[i].offsetTop; continue; }
      if (items[i].offsetTop > base + 2) return true;
    }
    return false;
  }

  function setExpanded(open) {
    moreItem.classList.toggle('is-open', open);
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function restoreAll() {
    while (panel.firstChild) {
      nav.insertBefore(panel.firstChild, moreItem);
    }
    moreItem.style.display = 'none';
    setExpanded(false);
  }

  function moveLastMovable() {
    var items = directItems();
    for (var i = items.length - 1; i >= 0; i--) {
      if (isMovable(items[i])) {
        panel.insertBefore(items[i], panel.firstChild); // prepend keeps source order
        return true;
      }
    }
    return false;
  }

  function recalc() {
    if (window.innerWidth < DESKTOP_MIN) { restoreAll(); return; }

    restoreAll();
    if (!isWrapping()) return;

    moreItem.style.display = '';
    var guard = 0;
    while (isWrapping() && guard++ < 50) {
      if (!moveLastMovable()) break;
    }
    if (!panel.firstChild) moreItem.style.display = 'none';
  }

  // Open/close: hover is handled in CSS; add click + keyboard for touch/a11y.
  toggle.addEventListener('click', function (e) {
    e.preventDefault();
    setExpanded(!moreItem.classList.contains('is-open'));
  });
  document.addEventListener('click', function (e) {
    if (!moreItem.contains(e.target)) setExpanded(false);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') setExpanded(false);
  });

  // Re-measure on resize (debounced to a frame).
  var raf;
  function schedule() {
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(recalc);
  }
  window.addEventListener('resize', schedule);

  // Measure immediately — this script is deferred, so the header is already
  // parsed. Reveal the menu right after the first pass (the CSS keeps it hidden
  // until .is-nav-ready) so items never flash-then-collapse. `finally` ensures
  // the menu is always revealed, even if a measure ever throws.
  try {
    recalc();
  } finally {
    nav.classList.add('is-nav-ready');
  }

  // Re-measure once webfonts settle — text widths can shift the wrap point.
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(recalc);
  }
  window.addEventListener('load', recalc);
})();
